<div
  class="tag h4-bold primary-80 text-capitalize d-flex align-items-center spacing-4 alert alert-bar alert-dismissible fade show m-0"
  [class.code-view]="codeView">
  @if (parentLabel) {
    <span class="primary-60" [ngClass]="{ 'text-ellipsis': ellipsis }">{{ parentText }}</span>
  }
  @if (parentLabel) {
    <span class="primary-60">/</span>
  }
  <span [ngClass]="{ 'text-ellipsis': ellipsis }">{{ label }}</span>
  <span class="dismiss-icon">
    @if (close) {
      <app-ce-icon
        [svg_class]="['primary-50', 'cursor-pointer']"
        name="cancel"
        aria-hidden="true"
        (click)="dismissOption($event)"></app-ce-icon>
    }
  </span>
</div>
